import { ChainID } from '@ankr.com/chains-list';
import { useMemo } from 'react';

import { ChainGroupID } from 'modules/endpoints/types';
import { evmGroups } from 'modules/endpoints/constants/evmGroups';
import {
  getCodeEnterprise,
  getCodeMrpc,
} from 'modules/chains/components/Snippets/utils/getCode';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useChainSelectors } from 'modules/chains/components/ChainSelectorsProvider';
import { useTechnology } from 'modules/chains/components/ConnectionSnippet/hooks/useTechnology';

export const useCodeSnippet = () => {
  const [technology, setTechnology] = useTechnology();

  const { isLoggedIn } = useAuth();

  const { isEnterprise, isPremium } = useAccountStatus();

  const { group } = useChainSelectors();

  const isGroupPublic = group.chains.every(chain => chain.isPublic);

  const [httpCode, wssCode] = useMemo(
    () =>
      isEnterprise
        ? getCodeEnterprise(technology, group)
        : getCodeMrpc({
            shouldAddPrefix: !isGroupPublic && !isLoggedIn,
            technology,
            urls: group.urls,
          }),
    [group, technology, isEnterprise, isGroupPublic, isLoggedIn],
  );

  // it's shity hack because of unexpected TAC testnets dependencies and grouping
  const isEvmTacGroup =
    group.id !== (ChainID.TAC_TESTNET_SPB_EVM as unknown as ChainGroupID);

  const isHidden = !evmGroups.includes(group.id) && isEvmTacGroup;

  return {
    httpCode,
    isHidden,
    setTechnology,
    technology,
    wssCode: isPremium ? wssCode : undefined,
  };
};
